import _isFunction from "lodash/isFunction";
import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Icon } from 'components/UI';
import { backButtonContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BackButton = function BackButton(_ref) {
  var className = _ref.className,
      onBack = _ref.onBack;
  var history = useHistory();
  return ___EmotionJSX("div", _extends({
    role: "button",
    tabIndex: 0,
    onClick: onBack && _isFunction(onBack) ? onBack : history.goBack,
    css: backButtonContainer
  }, className && {
    className: className
  }), ___EmotionJSX(Icon, {
    iconName: "la la-arrow-left",
    size: 20
  }));
};

BackButton.propTypes = {
  className: PropTypes.string,
  onBack: PropTypes.func
};
export default BackButton;